import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigsService } from '../../../config/app-configs.service';
import { HttpService, IResponseLower } from '../../../shared/cardholders-core/services/http-service.service';
import { IBenefitPlusResult, IDiscountType, IRegion } from '../models/benefit-plus-result';
import { IBenefitsPlusLobbyResult } from '../models/lobby-result';

@Injectable({
    providedIn: 'root'
})
export class BenefitsPlusService {
    type: IDiscountType = null;
    region: IRegion = null;
    sort: string = null;
    constructor(private appConfigsService: AppConfigsService, private httpSvc: HttpService) {}

    getBenefit(name: string, category: string): Observable<IResponseLower<IBenefitPlusResult>> {
        const httpParams = new HttpParams().set('name', name).set('category', category);
        return this.httpSvc.getLower<IBenefitPlusResult>(
            `${this.appConfigsService.appConfigs.apiUrl}/benefitsPlus/getDiscountPlus`,
            httpParams
        );
    }

    getAllBenefits(isMobile: boolean, page: number, loadLobbyTemplate: boolean = false, type: IDiscountType = null, region: IRegion = null, sort: string = null): Observable<IResponseLower<IBenefitsPlusLobbyResult>> {
        let httpParams = new HttpParams().set('isMobile', isMobile).set('page', page).set('loadLobby', loadLobbyTemplate);
        if (type?.typeUrlName) {
            httpParams = httpParams.set('type', type.typeUrlName);
        }
        if (region?.name) {
            httpParams = httpParams.set('region', region.name);
        }
        if (sort) {
            httpParams = httpParams.set('sort', sort);
        }
        return this.httpSvc.getLower<IBenefitsPlusLobbyResult>(`${this.appConfigsService.appConfigs.apiUrl}/benefitsPlus/getDiscountsPlus`, httpParams);
    }
}
